import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fromWithCompany, supabase } from "../config/supabaseClient";
import { startLoading, stopLoading } from "./commonSlice";
import { statuses } from "../constant/constants";
// Async thunk for inserting organogram data
export const insertOrganogram = createAsyncThunk(
  "organogram/insertOrganogram",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      // payload should be an array of organogram objects
      const { data, error } = await supabase
        .from("organograms")
        .insert(payload);
      if (error) {
        return rejectWithValue(error.message);
      }
      return data;
    } catch (err) {
      return rejectWithValue(err.message);
    } finally {
      dispatch(stopLoading());
    }
  }
);

export const fetchOrganogram = createAsyncThunk(
  "organogram/fetchOrganogram",
  async (companyId, { rejectWithValue, dispatch }) => {
    try {
      dispatch(startLoading());
      const { data, error } = await fromWithCompany("organograms")
        .select("*")
        .eq("status", statuses.ACTIVE);

      if (error && error.code != "PGRST116") throw error;

      const formattedData = data?.map((item) => ({
        id: item.id,
        departmentId: item.dept_id,
        name: item.dept_name,
        departmentHeadId: item.dept_head_id,
        parentDepartmentId: item.parent_dept_id,
        approvalRequired: item.approval_required,
      }));
      return formattedData;
    } catch (err) {
      return rejectWithValue(err.message);
    } finally {
      dispatch(stopLoading());
    }
  }
);

export const fetchOrganogramByDepartmentId = createAsyncThunk(
  "organogram/fetchOrganogramByDepartmentId",
  async (departmentId, { rejectWithValue, dispatch }) => {
    try {
      if (
        departmentId == null ||
        String(departmentId).trim() === "" ||
        String(departmentId).trim().toLowerCase() === "null"
      ) {
        return null;
      }
      dispatch(startLoading());
      const { data, error } = await fromWithCompany("organograms")
        .select("*")
        .eq("dept_id", departmentId)
        .eq("status", statuses.ACTIVE)
        .single();
      if (error) {
        return rejectWithValue(error.message);
      }
      return data;
    } catch (err) {
      return rejectWithValue(err.message);
    } finally {
      dispatch(stopLoading());
    }
  }
);
const organogramSlice = createSlice({
  name: "organogram",
  initialState: {
    loading: false,
    error: null,
    data: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(insertOrganogram.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(insertOrganogram.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(insertOrganogram.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchOrganogram.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrganogram.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchOrganogram.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default organogramSlice.reducer;
